<script lang="ts" setup>
import type { ArticleCategory } from '@/utils/types'
import { useArticleStore } from '@/stores'
import { dateFormat } from '../../../utils/helper';

const props = defineProps({
  categoryName: {
    type: String,
    default: null
  },
  date: {
    type: String,
    default: null
  }
})

const articleStore = useArticleStore()

const categories = computed(() => {
  return [
    {
      title: 'hence',
      link: '/hence',
    },
    ...articleStore.projectCategories.map(item => {
      return {
        link: `/hence/${item.id}`,
        title: item.subject
      }
    }),
    {
      title: '恆食堂',
      link: '/hence/recipe',
    },
    {
      title: '專題報導',
      link: '/hence/topic',
    },
    // {
    //   title: '歷期雜誌',
    //   link: '/hence/magazine',
    // },
  ]
})

const DD = dateFormat(props.date, 'DD')
const YYYY = dateFormat(props.date, 'YYYY')
const MMM = dateFormat(props.date, 'MMM', 'en-US')
</script>

<template>
  <div class="side">
    <div class="side__dateBox" v-if="categoryName !== '恆食堂'">
      <div class="side__dateBox__day">{{ DD }}</div>
      <div class="side__dateBox__right">
        <div class="side__dateBox__month">{{ MMM }}</div>
        <div class="side__dateBox__year">{{ YYYY }}</div>
      </div>
    </div>
    <section class="side__link">
      <nuxt-link :to="item.link" :class="{ active: categoryName === item.title }" v-for="(item, index) in categories"
        :key="index">
        <span class="side__link__inner">
          {{ item.title }}
          <svg-icon name="icon-symbol" />
        </span>
      </nuxt-link>
    </section>
    <Share round :border="false" />
  </div>
</template>

<style lang="scss" scoped>
.side {
  text-align: right;

  &__dateBox {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: toRem(24);
    color: $color-gray-2;
    font-family: $font-TextaAlt;

    &__day {
      font-size: toRem(30);
      line-height: 0.8;
      margin-right: toRem(3);
    }

    &__month,
    &__year {
      font-size: toRem(12);
      line-height: 1;
    }
  }

  &__link {
    display: flex;
    flex-direction: column;
    margin-bottom: toRem(24);

    a {
      display: block;
      margin-bottom: toRem(12);
      color: rgba($color-black-1, 0.5);
      font-weight: 400;
      line-height: 1.45;
      font-size: toRem(16);

      svg {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: toRem(17);
        height: toRem(7);
        color: $color-brand-4_1;
        pointer-events: none;
        opacity: 0;
        transform: scaleX(0);
        transition: all 0.5s;
      }

      &:hover,
      &.active {
        color: $color-brand-4_1;

        svg {
          opacity: 1;
          transform: scaleX(1);
        }
      }
    }

    &__inner {
      position: relative;
      display: inline-block;
      padding-left: toRem(25);
    }
  }
}
</style>
